var render, staticRenderFns
import script from "./rateList.vue?vue&type=script&lang=js&"
export * from "./rateList.vue?vue&type=script&lang=js&"
import style0 from "./rateList.vue?vue&type=style&index=0&id=965eb110&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports